var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramSaving48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Small./Saving48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogramSavings48",
    transform: "translate(3.000000, 4.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0.788596668 L6.23453196,3.31175019 L1.43520877,9.91745185 L1.43520877,18.0825481 L6.23453196,24.6882498 L14,27.2114033 L21.765468,24.6882498 L26.5647912,18.0825481 L26.5647912,9.91745185 L21.765468,3.31175019 L14,0.788596668 Z",
    id: "50c",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "20c",
    fill: "#FFFFFF",
    cx: 30,
    cy: 23,
    r: 10.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "dollar",
    transform: "translate(4.250000, 20.500000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Focus",
    fill: "#FFCC00",
    cx: 10,
    cy: 10,
    r: 9.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "$",
    transform: "translate(7.750000, 4.750000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.24839783,1.5 L2.24839783,0",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25,10.5 L2.25,9",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75,1.5 C2.69035594,1.5 2.56535594,1.5 1.875,1.5 C0.839466094,1.5 0,2.33946609 0,3.375 C0,4.41053391 0.839466094,5.25 1.875,5.25 L2.625,5.25 C3.66053391,5.25 4.5,6.08946609 4.5,7.125 C4.5,8.16053391 3.66053391,9 2.625,9 C1.93464406,9 1.80964406,9 0.75,9",
    id: "Oval-2"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramSaving48);
export default __webpack_public_path__ + "static/media/pictogramSaving48.a5fb15493d42c1f8e1af699e757eda76.svg";
export { ForwardRef as ReactComponent };